import React, { useEffect, useState } from "react"
import { Button, Stack, TextField, Typography, Divider } from "@mui/material"
import { useTranslation } from "react-i18next"
import { changePassword } from "src/services/api/user"
import { useSnackbar } from "src/providers/SnackbarProvider"

const PasswordChange = () => {
  const { snackbarShowMessage } = useSnackbar()
  const [oldPassword, setOldPassword] = useState<string>("")
  const [newPassword, setNewPassword] = useState<string>("")
  const [invalidNewPass, setInvalidNewPass] = useState<string>(" ")
  const [newPassword2, setNewPassword2] = useState<string>("")
  const [invalidNewPass2, setInvalidNewPass2] = useState<string>(" ")

  const [isFormInvalid, setFormInvalid] = useState<boolean>(false)

  const isValidPassword = (password: string) => {
    return /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~\\])[A-Za-z\d!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~\\]{8,60}$/.test(
      password
    )
  }
  const isValidPasswordConfirm = (password: string, passwordConfirmation: string) => {
    return password === passwordConfirmation && password !== ""
  }

  const { t } = useTranslation("profile")

  useEffect(() => {
    setInvalidNewPass(isValidPassword(newPassword) ? " " : t("password.wrong"))
    setInvalidNewPass2(isValidPasswordConfirm(newPassword, newPassword2) ? " " : t("password.noMatch"))
    setFormInvalid(!!invalidNewPass || !!invalidNewPass2)
  }, [newPassword, newPassword2, oldPassword])

  useEffect(() => {
    setFormInvalid(invalidNewPass !== " " || invalidNewPass2 !== " " || oldPassword === "")
  }, [invalidNewPass2, invalidNewPass, oldPassword])

  const changeUserPassword = async () => {
    try {
      await changePassword(oldPassword, newPassword)
      snackbarShowMessage(t("password.changeSuccess"), "success")
    } catch (e: any) {
      snackbarShowMessage(e.response.message || t("password.changeError"), "error")
    }
  }

  return (
    <form>
      <Stack alignItems={"flex-start"}>
        <Typography variant="h5">{t("password.title")}</Typography>
        <TextField
          label={t("password.current")}
          type="password"
          value={oldPassword}
          onChange={(e) => {
            setOldPassword(e.target.value)
          }}
          helperText=" "
          fullWidth
        ></TextField>
        <Divider flexItem sx={{ mb: 2, border: "none" }} />
        <TextField
          label={t("password.new")}
          type="password"
          value={newPassword}
          onChange={(e) => {
            setNewPassword(e.target.value)
          }}
          error={!(oldPassword === "") && invalidNewPass !== " "}
          helperText={!(oldPassword === "") ? invalidNewPass : " "}
          fullWidth
        ></TextField>
        <TextField
          label={t("password.newRepeat")}
          type="password"
          value={newPassword2}
          onChange={(e) => {
            setNewPassword2(e.target.value)
          }}
          error={!(newPassword === "") && invalidNewPass2 !== " "}
          helperText={!(newPassword === "") ? invalidNewPass2 : " "}
          fullWidth
        ></TextField>
        <Button variant="contained" color="primary" disabled={isFormInvalid} onClick={changeUserPassword}>
          {t("password.change")}
        </Button>
      </Stack>
    </form>
  )
}

export default PasswordChange
